export const FACEBOOK_URL = "https://www.facebook.com/manscaped/";

export const INSTAGRAM_URL = "https://www.instagram.com/manscaped/";

export const TWITTER_URL = "https://x.com/manscaped/";

export const YOUTUBE_URL = "https://www.youtube.com/channel/UCSFOWOgB_s52kkhzRaCS2gQ";

export const PINTEREST_URL = "https://www.pinterest.com/manscaped/";

export const TIKTOK_URL = "https://www.tiktok.com/@manscaped";

export const QUORA_URL = "https://manscaped.quora.com/";

export const TWITCH_URL = "https://www.twitch.tv/manscaped";
